export default function ServicesGrid() {
  return (
    <section className="py-24 bg-[#F4E8D8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-6xl font-serif text-gray-900">
            Our Core<br />
            <span className="text-[#E67E50]">Services</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 h-[600px]">
          <div className="relative rounded-2xl overflow-hidden shadow-lg group cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/7b9d1fbe724b53589c7abedc280090df.jpg"
              alt="Freight Transportation"
              className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute bottom-8 left-8">
              <h3 className="text-3xl font-bold text-white mb-2">Freight Transportation</h3>
              <p className="text-white/90 text-sm max-w-md">
                Reliable nationwide shipping solutions with real-time tracking and dedicated support for all your cargo needs.
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div className="relative rounded-2xl overflow-hidden shadow-lg bg-[#8B9A8E] h-1/2 group cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20warehouse%20interior%20with%20organized%20storage%20systems%2C%20industrial%20shelving%20with%20packages%20and%20inventory%2C%20warm%20ambient%20lighting%2C%20professional%20logistics%20facility%20photography%2C%20clean%20organized%20space%20with%20neutral%20warm%20tones%2C%20contemporary%20warehouse%20management%20aesthetic&width=800&height=400&seq=service-warehouse-001&orientation=landscape"
                alt="Warehousing Solutions"
                className="w-full h-full object-cover object-center opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-6 left-6">
                <h3 className="text-2xl font-bold text-white mb-1">Warehousing Solutions</h3>
                <p className="text-white/90 text-sm max-w-sm">
                  Secure storage facilities with advanced inventory management systems.
                </p>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-lg bg-[#E8B4A0] h-1/2 group cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20package%20handling%20and%20supply%20chain%20operations%2C%20cardboard%20boxes%20being%20organized%20in%20distribution%20center%2C%20warm%20lighting%20with%20soft%20peachy%20and%20beige%20tones%2C%20logistics%20worker%20managing%20inventory%2C%20clean%20modern%20warehouse%20environment%2C%20professional%20commercial%20photography&width=800&height=400&seq=service-supply-001&orientation=landscape"
                alt="Supply Chain Management"
                className="w-full h-full object-cover object-center opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-6 left-6">
                <h3 className="text-2xl font-bold text-white mb-1">Supply Chain Management</h3>
                <p className="text-white/90 text-sm max-w-sm">
                  End-to-end logistics coordination for seamless operations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
